import { render, staticRenderFns } from "./repayOverDueReport.vue?vue&type=template&id=70631a6e&scoped=true"
import script from "./repayOverDueReport.vue?vue&type=script&lang=js"
export * from "./repayOverDueReport.vue?vue&type=script&lang=js"
import style0 from "./repayOverDueReport.vue?vue&type=style&index=0&id=70631a6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70631a6e",
  null
  
)

export default component.exports